import React from 'react'
import { Button, Navbar } from "flowbite-react";

const TopNavbar = () => {
  return (
    <Navbar fluid rounded>
      <Navbar.Brand href="https://flowbite-react.com">
        {/* <span className="self-center whitespace-nowrap text-xl font-semibold dark:text-white">Internal Linking Analyzer</span> */}
      </Navbar.Brand>
      <div className="flex md:order-2">
        {/* <Button>Get started</Button> */}
        <Navbar.Toggle />
      </div>
      <Navbar.Collapse>
        <Navbar.Link href="/">
          Home
        </Navbar.Link>
        {/* <Navbar.Link href="#">About</Navbar.Link> */}
        <Navbar.Link href="/semi-automate-internal-link-building">Automate Internal Linking</Navbar.Link>
        {/* <Navbar.Link href="#">Pricing</Navbar.Link>
          <Navbar.Link href="#">Contact</Navbar.Link> */}
      </Navbar.Collapse>
    </Navbar>
  )
}

export default TopNavbar